import { render } from "./NotFound.vue?vue&type=template&id=39f85d20&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=39f85d20&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f85d20"]])

export default __exports__